export default {"src":"/corgi/pageapps/prepurchase/_next/static/media/favicon.4018bcbd.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};